/**
 * 获取地址栏参数
 * @param name
 * @returns {string}
 */
export const getUrlParam = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let url = location.href
  let search = url.split('?')[1]
  if (!search) {
    return ''
  }
  var r = search.substr(0).match(reg)
  if (r) return decodeURI(r[2])
  return ''
}



// WEBPACK FOOTER //
// ./src/utils/urlUtil.js